import React, { useEffect } from "react";
import {
  getPaymentDepositDateTime,
  getPaymentDepositSourceLabel,
} from "../paymentDepositLedgerUtils";
import { PaymentDepositCalendarDay } from "./paymentDepositTypes";

type Props = {
  day: PaymentDepositCalendarDay;
  onClose: () => void;
};

const won = (value: number) => `${value.toLocaleString("ko-KR")}원`;

const PaymentDepositDayPopover = ({ day, onClose }: Props) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <section
      role="dialog"
      aria-modal="false"
      aria-label={`${day.date} 거래·승인 상세`}
      className="fixed inset-x-3 top-[8vh] z-[180] mx-auto max-h-[84vh] max-w-3xl overflow-y-auto border border-slate-300 bg-white p-4 text-left shadow-2xl sm:inset-x-6 sm:p-5"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-black text-emerald-700">
            입금관리 승인일 상세
          </p>
          <h5 className="mt-1 text-lg font-black text-slate-950">
            {day.date} 거래·승인 상세
          </h5>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="min-h-[44px] min-w-[52px] border border-slate-300 px-3 text-xs font-black text-slate-700"
        >
          닫기
        </button>
      </div>

      {day.transactions.length > 0 && (
        <div className="mt-4">
          <h6 className="text-sm font-black text-slate-950">
            KCP 승인 거래 {day.transactions.length}건 · {won(day.transactionAmount)}
          </h6>
          <div className="mt-2 space-y-2">
            {day.transactions.map(({ request, settlement }, index) => {
              const approved = getPaymentDepositDateTime(request);
              return (
                <article
                  key={
                    request.paymentRequestId ||
                    request.id ||
                    `${day.date}:transaction:${index}`
                  }
                  className="border border-slate-200 bg-slate-50 p-3"
                >
                  <div className="flex flex-wrap items-start justify-between gap-2">
                    <div>
                      <p className="font-black text-slate-950">
                        {request.vendorCode || "코드 미연결"} ·{" "}
                        {request.vendorBusinessName ||
                          request.customerName ||
                          "거래처 미연결"}
                      </p>
                      <p className="mt-1 text-xs font-bold text-slate-600">
                        {approved.date} {approved.time || "시각 미확인"} ·{" "}
                        {getPaymentDepositSourceLabel(request)}
                      </p>
                    </div>
                    <strong className="text-sm font-black text-emerald-800">
                      {won(settlement.settlementAmount)}
                    </strong>
                  </div>
                  <dl className="mt-2 grid grid-cols-1 gap-1 text-xs font-bold text-slate-700 sm:grid-cols-2">
                    <div>카드사: {request.approvalCardName || "-"}</div>
                    <div>승인번호: {request.approvalCode || "-"}</div>
                    <div className="sm:col-span-2">
                      거래사업자: {request.paymentCompanyName || "-"}
                    </div>
                  </dl>
                </article>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
};

export default PaymentDepositDayPopover;
